/* eslint-disable react/jsx-no-bind */
import * as menuBoard from "../../lib/api/menuBoard";
import * as menuBoardTemplate from "../../enums/menuBoardTemplate";
import * as menuBoardType from "../../enums/menuBoardType";
import Loader from "../Loader";
import logger from "../../lib/logger";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { Button, Grid, Row, Col, Table } from "react-bootstrap";
import { css, StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
    description: {
        marginBottom: "32px",
    },
});

const strings = {
    title: "Menu Board | Habit CMS",
    menuBoard: menuName => `Menu Board - ${menuName}`,
    description:
        "The below table shows each portion of the menu board. The section describes where the section resides on the board, the category is the menu category shown in that section, and the template name is the style/format used to render that section. Only some template types are editable. For changes to sections without an edit link, code changes must be made. Click edit to update the content of a given section.",
    boardSection: "Board Section",
    menuCategory: "Menu Category",
    templateName: "Template Name",
    edit: "Edit",
    editMenuBoardSectionUrl: "/menu-board/edit-section",
};

function getTemplateName(template, width, height) {
    switch (template) {
        case menuBoardTemplate.category_product_full_description:
            return "Category Product - Full Description";
        case menuBoardTemplate.category_product_name_price_cal:
            return "Category - Products with name, price, and calories only";
        case menuBoardTemplate.category_hide_products:
            return "Category - Hide items";
        case menuBoardTemplate.category_product_as_option:
            return "Category - Products as Options";
        case menuBoardTemplate.category_with_ad_logo_small:
            return "Category - With ad logo";
        case menuBoardTemplate.feature:
            return `Marketing Space - ${width} x ${height}`;
        case menuBoardTemplate.legend:
            return "Icon Legend";
        case menuBoardTemplate.disclaimer:
            return "Disclaimer";
        default:
            return "";
    }
}

export default class MenuBoardPage extends PureComponent {
    static propTypes = {
        history: PropTypes.object.isRequired,
    };

    state = {
        loading: true,
        id: "",
        createDate: "",
        name: "",
        sections: [],
    };

    componentDidMount() {
        this._isMounted = true;
        document.title = strings.title;
        menuBoard
            .getMenuBoard()
            .then(resp => {
                if (this._isMounted) {
                    this.setState({
                        id: resp.id,
                        createDate: resp.createDate,
                        name: resp.name,
                        sections: resp.sections,
                        loading: false,
                    });
                }
            })
            .catch(err => {
                logger.warn(err);
                if (this._isMounted) {
                    this.setState({ loading: false });
                }
            });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <Grid>
                <Row>
                    <Col md={12}>
                        <h3>{strings.menuBoard(this.state.name)}</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <div className={css(styles.description)}>{strings.description}</div>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>{strings.boardSection}</th>
                                    <th>{strings.menuCategory}</th>
                                    <th>{strings.templateName}</th>
                                    <th>{strings.edit}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading
                                    ? null
                                    : this.state.sections.map(s => (
                                          <tr key={s.id}>
                                              <td>{s.name}</td>
                                              <td>{s.categoryName}</td>
                                              <td>
                                                  {getTemplateName(
                                                      s.template,
                                                      s.layout.width,
                                                      s.layout.height,
                                                  )}
                                              </td>
                                              <td>
                                                  {s.type !== menuBoardType.legend && (
                                                          <Button
                                                              bsStyle="primary"
                                                              to={`${strings.editMenuBoardSectionUrl}/${s.id}`}
                                                              onClick={() => {
                                                                  this.props.history.push(
                                                                      `${strings.editMenuBoardSectionUrl}/${s.id}`,
                                                                      {
                                                                          menuName: this.state.name,
                                                                          width: s.layout.width,
                                                                          height: s.layout.height,
                                                                      },
                                                                  );
                                                              }}
                                                          >
                                                              {strings.edit}
                                                          </Button>
                                                      )}
                                              </td>
                                          </tr>
                                      ))}
                            </tbody>
                        </Table>
                        {this.state.loading ? <Loader /> : null}
                    </Col>
                </Row>
            </Grid>
        );
    }
}
